module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "viewer"
    }
  }, [_c('header-nav'), _vm._v(" "), _c('main', {
    staticClass: "main fix"
  }, [_c('transition', [_c('keep-alive', [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "copyright"
  }, [_vm._v("\n    powerd by "), _c('a', {
    attrs: {
      "href": "https://github.com/Ma63d/leetcode-viewer",
      "target": "_blank"
    }
  }, [_vm._v("leetcode-viewer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-01f5b1f0!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/Viewer.vue
// module id = 72
// module chunks = 2